// extracted by mini-css-extract-plugin
export default {"Box":"Suche_Box__SnVow","SucheBox":"Suche_SucheBox__TIujz","BoxInnerHeader":"Suche_BoxInnerHeader__p0EKc","BoxHeader":"Suche_BoxHeader__ij0bn"};